import { inject } from '@angular/core';
import { Route, Router, ActivatedRouteSnapshot } from '@angular/router';
import { validateCampaign } from '@kanek/shared-data-access';

export const appRoutes: Route[] = [
  // Campaign error page (no guard needed)
  {
    path: 'campaign-error',
    loadComponent: () => import('./campaign-error/campaign-error.component').then(m => m.CampaignErrorComponent),
  },

  // Protected experience routes - all require valid campaign
  {
    path: 'experience',
    loadComponent: () => import('./experience/experience.component'),
    canActivate: [validateCampaign],
  },
  {
    path: 'experience/play',
    loadComponent: () => import('./play/play.component'),
    canActivate: [validateCampaign],
  },
  {
    path: 'experience/win',
    loadComponent: () => import('./win/win.component'),
    canActivate: [validateCampaign],
  },
  {
    path: 'experience/redeem',
    loadComponent: () => import('./redeem/redeem.component'),
    canActivate: [validateCampaign],
  },

  // Utility routes
  {
    path: 'api/version',
    loadComponent: () => import('./version/version.component'),
  },
  {
    path: 'unsubscribe',
    loadComponent: () => import('./unsubscribe/unsubscribe.component'),
  },

  // Default redirects
  {
    path: '',
    redirectTo: redirectToExperience,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: redirectToExperience,
  },
];

function redirectToExperience(redirectData: Pick<ActivatedRouteSnapshot, 'queryParams'>) {
  const router = inject(Router);
  const sid = redirectData.queryParams['s'];
  const iid = redirectData.queryParams['i'];

  if (sid) {
    // Forward both s (short code) and i (session ID) so email/SMS recovery links work end-to-end
    const queryParams: Record<string, string> = { s: sid };
    if (iid) queryParams['i'] = iid;
    return router.createUrlTree(['/experience'], { queryParams });
  } else {
    // No short code provided - redirect to campaign error page
    return router.createUrlTree(['/campaign-error'], {
      queryParams: {
        status: 'missing_short_code',
        message: 'No campaign code was provided in the link.',
        shortCode: '',
        actions: JSON.stringify([
          'Check that you scanned the QR code correctly',
          'Ask for a new link from the venue',
          'Contact support if the problem persists'
        ])
      }
    });
  }
}
/**
 * Navigate to the correct prize destination based on session contact state.
 * Extracted to avoid duplicating this routing decision across experience components.
 */
export function navigateToPrizeDestination(
  session: { contactEmail?: string; contactPhone?: string },
  router: Router
): void {
  if (session.contactEmail || session.contactPhone) {
    router.navigate(['/experience/redeem']);
  } else {
    router.navigate(['/experience/win']);
  }
}